import React from 'react';
import { motion } from 'framer-motion';
export interface Tab {
  id: string;
  label: string;
  count?: number;
}
interface TabGroupProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
}
export function TabGroup({
  tabs,
  activeTab,
  onChange,
  className = ''
}: TabGroupProps) {
  return <div className={`flex items-center gap-1 md:gap-2 lg:gap-6 border-b border-clinical-gray-200 overflow-x-auto no-scrollbar ${className}`} data-id="element-252">
      {tabs.map(tab => {
      const isActive = activeTab === tab.id;
      return <button key={tab.id} onClick={() => onChange(tab.id)} className={`
              relative py-3 md:py-4 px-1 text-sm md:text-body font-medium transition-colors whitespace-nowrap min-h-[44px]
              ${isActive ? 'text-medical-green' : 'text-text-secondary hover:text-text-primary'}
            `} data-id="element-253">
            <div className="flex items-center gap-2" data-id="element-254">
              {tab.label}
              {tab.count !== undefined && <span className={`
                  inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs
                  ${isActive ? 'bg-medical-green-50 text-medical-green' : 'bg-clinical-gray-100 text-text-secondary'}
                `} data-id="element-255">
                  {tab.count}
                </span>}
            </div>

            {isActive && <motion.div layoutId="activeTabIndicator" className="absolute bottom-0 left-0 right-0 h-0.5 bg-medical-green" initial={false} transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30
        }} data-id="element-256" />}
          </button>;
    })}
    </div>;
}